import { Anchor } from './Anchor';
import { MediumText } from './Text';
import Typewriter from '../design-system/Typewriter';
import styled from 'styled-components';

export const HighlightSpan = styled.span`
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 50%, rgba(247, 209, 200, 0.5) 50%);
  background-size: 200%;
  background-position: 0 0;
  display: inline;
  transition: 0.5s ease;
  &:hover {
    background-position: -100% 0;
    text-decoration: none;
    color: #064554;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  max-width: 780px;
  margin-left: 0;
  @media (max-width: 1180px) {
    width: 100%;
    max-width: 760px;
    align-items: flex-start;
  }
  @media (max-width: 1024px) {
    width: 85%;
    margin-left: 0;
    padding-left: 12px;
    padding-bottom: 32px;
    margin-right: auto;
  }
`;
const Heading = styled.h1`
  color: #363636;
  font-size: 32px;
  line-height: 1.15;
  overflow-wrap: anywhere;
`;

export default function AboutMeCard(): React.ReactElement {
  return (
    <Container>
      <Heading>
        Hey! I'm{' '}
        <HighlightSpan>
          <Typewriter>Aiden.</Typewriter>
        </HighlightSpan>
      </Heading>
      <MediumText>I'm a researcher working on alignment.</MediumText>
      <MediumText>
        At OpenAI, I train models to be more honest and helpful, develop techniques that scale with
        more capable models, and measure alignment of our models and study sources of misalignments
        across the training stack. Earlier, I worked on pushing the frontier of agentic visual
        capabilities: developing methods and infrastructure for OpenAI's models to reason with
        images in chain of thought and create economically useful visual artifacts.
      </MediumText>
      <MediumText>
        Prior to OpenAI, I worked at Applied Intuition on ML data systems and infrastructure, and
        Nvidia on facial recognition models. I've also led an experimental national digital petition
        system in Singapore to explore novel democratic participation mechanisms in 2022 at Open
        Government Products.
      </MediumText>
      <MediumText>
        I received my Bachelor's degree in Computer Science from the National University of
        Singapore and studied humanities under the University Scholars Programme. In 2019, I was a
        visiting student and researcher at Stanford University where I worked on retrotransposon
        genome pipelines at the Ashley Lab for patients with undiagnosed diseases.
      </MediumText>
      <MediumText>
        I like creating things that help people. For fun, I've matchmade over 102,873 people with
        the{' '}
        <HighlightSpan>
          <Anchor target="_blank" href="https://aphrodite.global/" rel="noreferrer">
            Aphrodite Project
          </Anchor>
        </HighlightSpan>
        , with at least 12 marriages and engagements since 2019.
      </MediumText>
    </Container>
  );
}
